import { render, staticRenderFns } from "./signin-page.vue?vue&type=template&id=77ba793e&scoped=true&"
import script from "./signin-page.vue?vue&type=script&lang=js&"
export * from "./signin-page.vue?vue&type=script&lang=js&"
import style0 from "./signin-page.vue?vue&type=style&index=0&id=77ba793e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77ba793e",
  null
  
)

export default component.exports
import {QForm,QBtn,QSpinnerIos,QSeparator,QInput,QIcon} from 'quasar'
component.options.components = Object.assign(Object.create(component.options.components || null), component.options.components || {}, {QForm,QBtn,QSpinnerIos,QSeparator,QInput,QIcon})
